module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("The author had an extensive aviation career as a military flight officer and as an International Captain with United Airlines.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("He began his writing career at the urging of his wife, Roseanne as he often told her tales of his travels and adventures.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("Captain Angelo is an author, movie script writer, film producer, Reality Show writer/producer with several books and film projects in development.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("He resides with his wife in New England, USA.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0